import { redirect } from "@tanstack/react-router"

/**
 * Shared auth guard for the `_authenticated` layout routes.
 *
 * The top-level tree (no-QR fallback) and the `/qr/$qrLookupID` tree redirect
 * the same way; only the QR tree has a `qrLookupID` to forward.
 */
export function assertAuthenticated(args: {
  isAuthenticated: boolean
  redirectHref: string
  qrLookupID?: string
}) {
  if (args.isAuthenticated) return

  throw redirect({
    to: "/auth/sign-in",
    search: {
      redirect: args.redirectHref,
      qrLookupID: args.qrLookupID,
      phone: undefined,
      plate: undefined,
      conversionFlow: undefined,
      email: undefined,
    },
  })
}
